import { gql } from "@apollo/client";

/**
 * Error monitoring for /admin/errors.
 *
 * Rows are kinds of error, not occurrences — `occurrences` is the count. See
 * ErrorLog on the server for why.
 */
export const GET_ERROR_LOGS = gql`
  query GetErrorLogs($limit: Int, $offset: Int, $status: String, $search: String) {
    errorLogs(limit: $limit, offset: $offset, status: $status, search: $search) {
      total
      stats {
        totalGroups
        unresolvedGroups
        unhandledGroups
        totalOccurrences
        activeLastDay
        lastSeenAt
        retentionDays
      }
      logs {
        id
        exceptionClass
        message
        origin
        handled
        severity
        source
        context
        occurrences
        firstSeenAt
        lastSeenAt
        resolvedAt
        resolved
        copiedAt
      }
    }
  }
`;

export const GET_ERROR_LOG = gql`
  query GetErrorLog($id: ID!) {
    errorLog(id: $id) {
      id
      fingerprint
      exceptionClass
      message
      origin
      backtrace
      handled
      severity
      source
      context
      occurrences
      firstSeenAt
      lastSeenAt
      resolvedAt
      resolved
      copiedAt
    }
  }
`;

